// extracted by mini-css-extract-plugin
module.exports = {"main_page":"TRViwerPage_main_page__Jgjc8","main_header":"TRViwerPage_main_header__v0nHW","content":"TRViwerPage_content__tMTv_"};